import { Typography } from "@repo/design-system";
import { ZoomableImage } from "./ZoomableImage";

export function TheProject() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3 text-center">
        <Typography as="h1" variant="heading-2" className="text-contentPrimary">
          Broad Spectrum Antivirals Research Initiative
        </Typography>
      </div>

      {/* Construction workflow diagram */}
      <div className="mx-auto w-full max-w-lg">
        <ZoomableImage
          src="/bsa-db-workflow.jpg"
          alt="Construction of BSA-DB: acquisition from the WHO R&D Blueprint, PubChem, ChEMBL and BindingDB with LLM-assisted target extraction and validation, integration and curation, and release, audit and downstream analyses"
          caption="Construction of BSA-DB — click to zoom"
        />
      </div>

      {/* Description */}
      <div className="flex flex-col gap-4">
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed">
          Several viruses with pandemic potential are listed in the{" "}
          <a
            href="https://www.who.int/publications/m/item/pathogens-prioritization-a-scientific-framework-for-epidemic-and-pandemic-research-preparedness"
            target="_blank"
            rel="noopener noreferrer"
            className="text-contentBrand underline underline-offset-2 font-semibold hover:opacity-70">
            WHO Blueprint priority diseases framework
          </a>{" "}
          due to their ability to cause severe global health consequences. The
          recent COVID-19 outbreak further highlighted the urgent need for rapid
          identification of active antiviral compounds against such pathogens.
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed">
          In addition, previous studies have shown that some molecules active
          against one virus may also exhibit activity against others. These
          compounds, known as broad-spectrum antivirals, are of particular
          interest as they may provide a foundation for rapid therapeutic
          response during emerging outbreaks. A well-curated collection of such
          molecules can therefore play an important role in preparedness against
          future pandemics.
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed">
          In this project, we present, to the best of our knowledge, the largest
          curated database of broad-spectrum antiviral compounds targeting these
          high-priority viruses. Data have been integrated from three publicly
          available sources: PubChem, BindingDB, and ChEMBL. The database
          includes molecules with reported activity below 10,000 nM that
          demonstrate activity against more than one virus.
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed">
          As this field is continuously evolving, we plan to update the database
          every six months to ensure it remains current and comprehensive. We
          also strongly encourage other researchers to contribute their datasets
          of broad-spectrum antivirals or virus-specific activity data to
          improve dataset diversity and scientific impact. To submit data,
          please visit the Contact Us section.
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed">
          In addition, previous studies have shown that some molecules active
          against one virus may also exhibit activity against others. These
          compounds, known as broad-spectrum antivirals, are of particular
          interest as they may provide a foundation for rapid therapeutic
          response during emerging outbreaks. A well-curated collection of such
          molecules can therefore play an important role in preparedness against
          future pandemics.
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary leading-relaxed italic text-b700">
          This work is a collaboration between{" "}
          <a
            href="https://denovosciences.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-contentBrand underline underline-offset-2 font-semibold hover:opacity-70">
            Denovo Sciences
          </a>{" "}
          and the{" "}
          <a
            href="https://imb.am/antiviral-drugs-discovery/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-contentBrand underline underline-offset-2 font-semibold hover:opacity-70">
            Laboratory of Antiviral Drug Discovery of Institute of Molecular
            Biology
          </a>{" "}
          Laboratory of Antiviral Drug Discovery of Institute of Molecular
          Biology of NAS RA. At Denovo Sciences, we develop AI-driven
          technologies for small-molecule drug discovery, enabling exploration
          of targets that remain challenging for both conventional and existing
          AI-based approaches.
        </Typography>
      </div>
    </div>
  );
}
